export const isInBrowser = (typeof document !== 'undefined');
export const isOnServer = !isInBrowser;
